import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { from, of } from 'rxjs';
import {
  catchError,
  map,
  mergeMap,
  withLatestFrom,
  tap,
  filter,
} from 'rxjs/operators';
import {
  getRewards,
  getRewardsFailure,
  getRewardsCatAndSubCatPreference,
  getRewardsCatAndSubCatPreferenceFailure,
  getRewardsCatAndSubCatPreferenceSuccess,
  getRewardsSuccess,
} from './rewards.actions';
import { Store } from '@ngrx/store';
import { RewardsState } from './rewards.state';
import {
  selectRewardsCatAndSubCatPreferenceParams,
  selectRewardsParams,
} from './rewards.selector';
import { RewardPreferenceCategory } from 'src/app/utility/model/reward';
import { ApiService } from 'src/app/services/api-services/api.service';

@Injectable()
export class RewardEffects {
  constructor(
    private apiService: ApiService,
    private actions$: Actions,
  ) {}

  private store = inject(Store<RewardsState>);

  // get all rewards listing
  getRewards$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getRewards),
      withLatestFrom(this.store.select(selectRewardsParams)),
      mergeMap(([_, rewardParams]) =>
        from(this.apiService.getRewardSearch(rewardParams, true)).pipe(
          map((rewards: any) => getRewardsSuccess({ rewards })),
          catchError((error) => of(getRewardsFailure({ error }))),
        ),
      ),
    ),
  );

  // get reward category preference
  getRewardsCatAndSubCatPreference$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getRewardsCatAndSubCatPreference),
      withLatestFrom(
        this.store.select(selectRewardsCatAndSubCatPreferenceParams),
      ),
      mergeMap(([_, params]) => {
        return from(this.apiService.getRewardPreferenceCategory(params)).pipe(
          map((rewardCategories: RewardPreferenceCategory[]) =>
            getRewardsCatAndSubCatPreferenceSuccess({ rewardCategories }),
          ),
          catchError((error) =>
            of(getRewardsCatAndSubCatPreferenceFailure({ error })),
          ),
        );
      }),
    ),
  );
}
